import {createActionCreators, createReducerFunction, ImmerReducer} from 'immer-reducer'

export type State = {
    version: string,
    urlVideo: string
};

export const initialState: State = {
    version: "",
    urlVideo: ""
};

export class AppGlobalState extends ImmerReducer<State>{
    setVersion(version: string){
        this.draftState.version = version;
    };

    setUrlVideo(urlVideo: string){
        this.draftState.urlVideo = urlVideo;
    }
}

export const AppGlobalAction = createActionCreators(AppGlobalState)
export const appGlobalReducerFunction = createReducerFunction(AppGlobalState,initialState)